import {
  GET_FAQ,
  GET_FAQS,
  FAQ_ERROR,
  DELETE_FAQ,
  ADD_FAQ,
  UPDATE_FAQ
} from '../actions/types';

const initialState = {
  faq: null,
  faqs: [],
  loading: true,
  error: {}
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_FAQ:
      return {
        ...state,
        faq: payload,
        loading: false
      };
    case GET_FAQS:
      return {
        ...state,
        faqs: payload,
        loading: false
      };
    case ADD_FAQ:
      return {
        ...state,
        faqs: [payload, ...state.faqs],
        loading: false
      };
    case UPDATE_FAQ:
      return {
        ...state,
        faqs: state.faqs.map(item => 
          item._id === payload._id ? payload : item
        ),
        faq: payload,
        loading: false
      };
    case DELETE_FAQ:
      return {
        ...state,
        faqs: state.faqs.filter(item => item._id !== payload),
        loading: false
      };
    case FAQ_ERROR:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
